(ns manage.external-template-ocp.view
  (:require ["@mui/material/Button$default" :as Button]
            [common.ocp.view :refer [defocp ocp]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [manage.external-template-ocp.db :as form]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$]]))

(defocp external-template-ocp :external-template/add []
  (uix/use-effect (fn []
                    (rf/dispatch [:external-template-ocp.db/init])
                    (fn []
                      (rf/dispatch [:external-template-ocp.db/destroy])))
                  [])
  ($ ocp
     {:title "Add Template"
      :footer ($ Button {:type "submit" :variant "contained"}
                 "Add Template")
      :on-submit #(rf/dispatch [:external-template-ocp.db/submit])}
     ($ form-field
        {:label "URL"
         :err-msg (form/use-error-message [:template/url])}
        ($ input
           (merge (form/use-bind-control [:template/url])
                  {:type "text"})))
     ($ form-field
        {:label "Width"
         :err-msg (form/use-error-message [:template/width])}
        ($ input
           (merge (form/use-bind-control [:template/width]
                                         {:f int})
                  {:type "number"})))
     ($ form-field
        {:label "Height"
         :err-msg (form/use-error-message [:template/height])}
        ($ input
           (merge (form/use-bind-control [:template/height]
                                         {:f int})
                  {:type "number"})))))
